import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationEnd } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from './services/auth.service';
import {Router} from '@angular/router';
import { AuthFacade } from '@cradua/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthenticationService,
    private myRoute: Router, public authFacade: AuthFacade,){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log("Logged Serv up", this.auth.isLoggednIn());
      if(this.auth.isLoggednIn()){


        this.authFacade.getLoginUser;
        this.auth.getUser();


        return true;
      }else{
        this.myRoute.navigate(["auth/login"]);
        return false;
      }
  }

}
